import { render, staticRenderFns } from "./AttendanceCorrectionsSummary.vue?vue&type=template&id=343c220b"
import script from "./AttendanceCorrectionsSummary.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrectionsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports